import React from 'react';
import { LazyImage } from 'shared/components/LazyImage';
import mapImage from './assets/map.png';
import { PIN_POSITIONS } from './constants';
import { Pin } from '../Pins';
import * as styles from './styles.css';
import { usePinPhase } from 'shared/hooks/usePinPhase';
import { TDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

export interface IMapBlockProps {
  showPromoPins: boolean;
  device: TDeviceType;
}

export const MapBlock: React.FC<IMapBlockProps> = ({ showPromoPins, device }) => {
  const { showPromoPinsContent, isSimpleExiting, isPromoExiting, phase } = usePinPhase(showPromoPins);

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['map-block']}>
        <LazyImage
          src={mapImage}
          alt="map"
          wrapperLoadingClassName={styles['no-shadow']}
          wrapperClassName={styles['map']}
        />
        {PIN_POSITIONS.map((position, index) => (
          <Pin
            isPromoExiting={isPromoExiting}
            showPromoPinsContent={showPromoPinsContent}
            device={device}
            key={index}
            position={position}
            isPromoVisible={phase === 'promo'}
            isEntering={phase === 'simple'}
            isExiting={isSimpleExiting}
          />
        ))}
      </div>
    </div>
  );
};
